import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyOutlined } from "@ant-design/icons";
import { App, Tooltip, theme } from "antd";
import { COLOR_PRIMARY_SOFT_BG } from "../../../style/antdTheme.js";
import { __ } from "../../../utils/i18n.js";
import { MATOMO_MASK } from "../../../utils/matomoMask.js";
const LicenseKeyPill = ({ value, copyLabel, copiedMessage })=>{
    const { token } = theme.useToken();
    const { message } = App.useApp();
    const label = copyLabel ?? __("Copy license key");
    const copied = copiedMessage ?? __("License key copied to clipboard.");
    const copy = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        await navigator.clipboard.writeText(value);
        message.info(copied);
    };
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: label,
        children: /*#__PURE__*/ _jsxs("button", {
            type: "button",
            className: "rc-account-v2-license-pill",
            style: {
                background: COLOR_PRIMARY_SOFT_BG,
                color: token.colorTextHeading
            },
            onClick: copy,
            "aria-label": label,
            children: [
                /*#__PURE__*/ _jsx("code", {
                    className: "rc-account-v2-license-pill__value",
                    ...MATOMO_MASK,
                    children: value
                }),
                /*#__PURE__*/ _jsx(CopyOutlined, {
                    className: "rc-account-v2-license-pill__icon",
                    style: {
                        color: token.colorPrimary
                    },
                    "aria-hidden": true
                })
            ]
        })
    });
};
export { LicenseKeyPill };
